import { isNil } from 'lodash';

import { AgingDetailDateRangeTypeEnum } from 'api/backofficeApiClient';

const getPeriodTitle = (period: string | undefined) => {
  if (isNil(period)) return;

  switch (+period) {
    case AgingDetailDateRangeTypeEnum.LessThan30:
      return '≤ 30 Days';
    case AgingDetailDateRangeTypeEnum.MoreThan30:
      return '31 - 60 Days';
    case AgingDetailDateRangeTypeEnum.MoreThan60:
      return '61 - 90 Days';
    case AgingDetailDateRangeTypeEnum.MoreThan90:
      return '> 90 Days';
    case AgingDetailDateRangeTypeEnum.MoreThen0:
      return 'Total Balance';
  }
};

export { getPeriodTitle };
